import { FixedBottomArea } from "./FixedBottomArea";
import { ReadyHelper } from "Events/Scripts/ReadyHelper";
import { Container } from "typescript-ioc";

import "../Styles/FixedBottomArea.css";

const fixedBottomArea = new FixedBottomArea();

Container.get(ReadyHelper).bindDomReady(() => {
    fixedBottomArea.init();
});
